
(() => {
  if (window.LKMotion) return;
  const root = document.documentElement;
  const css = getComputedStyle(root);
  const read = (n, f) => (css.getPropertyValue(n) || '').trim() || f;
  const ms = (v, f) => { const n = parseFloat(v); if (!isFinite(n)) return f; return /ms\s*$/.test(v) ? n : /s\s*$/.test(v) ? n * 1000 : f; };
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const hasLinear = CSS.supports('transition-timing-function', 'linear(0, 1)');
  const curve = { spring: hasLinear ? read('--lk-rd-spring', 'ease-out') : 'cubic-bezier(.2,.9,.25,1.12)', soft: hasLinear ? read('--lk-rd-spring-soft', 'ease-out') : 'cubic-bezier(.3,.7,.2,1)' };
  const T = { spring: ms(read('--lk-rd-spring-dur', '580ms'), 580), soft: ms(read('--lk-rd-spring-soft-dur', '400ms'), 400), reveal: ms(read('--lk-rd-reveal-dur', '1100ms'), 1100), stagger: ms(read('--lk-rd-reveal-stagger', '100ms'), 100), count: ms(read('--lk-rd-count-dur', '1400ms'), 1400) };

  
  function animateHeight(details, open) {
    const body = details.querySelector(':scope > [data-lk-collapse-body]');
    if (!body || reduced.matches || !body.animate) { details.open = open; return; }
    details._lkAnim?.cancel();
    const start = details.open ? body.getBoundingClientRect().height : 0;
    if (open) details.open = true;
    body.style.height = 'auto';
    const end = open ? body.getBoundingClientRect().height : 0;
    details.classList.toggle('is-closing', !open);
    const anim = body.animate([{ height: start + 'px', opacity: open ? .35 : 1 }, { height: end + 'px', opacity: open ? 1 : 0 }],
      { duration: open ? T.spring : T.soft, easing: open ? curve.spring : curve.soft, fill: 'both' });
    details._lkAnim = anim; body.style.overflow = 'hidden';
    let done = false;
    const cleanup = () => {
      if (done || details._lkAnim !== anim) return; done = true;
      if (!open) details.open = false;
      details.classList.remove('is-closing'); body.style.height = ''; body.style.overflow = '';
      anim.cancel(); details._lkAnim = null;
    };
    anim.onfinish = cleanup; setTimeout(cleanup, (open ? T.spring : T.soft) + 80);
  }
  function toggle(details, force) {
    const willOpen = force ?? (!details.open || details.classList.contains('is-closing'));
    const group = details.dataset.lkGroup;
    if (willOpen && group) document.querySelectorAll(`details.lk-rd-collapse[data-lk-group="${CSS.escape(group)}"][open]`)
      .forEach(o => { if (o !== details) animateHeight(o, false); });
    animateHeight(details, willOpen);
  }
  document.addEventListener('click', e => {
    const summary = e.target.closest('details.lk-rd-collapse > summary');
    if (summary) { e.preventDefault(); toggle(summary.parentElement); }
  });

  
  const outside = e => document.querySelectorAll('details.lk-rd-dropdown[open]').forEach(d => { if (!d.contains(e.target)) toggle(d, false); });
  document.addEventListener('pointerdown', outside);
  document.addEventListener('focusin', outside);
  document.addEventListener('keydown', e => {
    const d = e.target.closest?.('details.lk-rd-dropdown'); if (!d) return;
    const items = [...d.querySelectorAll('.lk-rd-dropdown__option')];
    if (e.key === 'Escape') { e.preventDefault(); toggle(d, false); d.querySelector('summary').focus(); return; }
    if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(e.key)) return;
    e.preventDefault(); if (!d.open) toggle(d, true);
    const i = items.indexOf(document.activeElement);
    const next = e.key === 'Home' ? 0 : e.key === 'End' ? items.length - 1 : i < 0 ? (e.key === 'ArrowUp' ? items.length - 1 : 0) : (i + (e.key === 'ArrowUp' ? -1 : 1) + items.length) % items.length;
    items[next]?.focus();
  });

  
  function reveal(list) {
    list.map(el => ({ el, r: el.getBoundingClientRect() }))
      .sort((a, b) => a.r.top - b.r.top || a.r.left - b.r.left)
      .forEach(({ el }, i) => {
        el.dataset.lkAnimateState = 'done';
        const a = el.animate([{ opacity: 0, transform: 'translateY(28px) scale(.98)' }, { opacity: 1, transform: 'none' }],
          { duration: T.reveal, easing: curve.spring, delay: Math.min(i, 5) * T.stagger, fill: 'backwards' });
        a.onfinish = () => a.cancel();
      });
  }

  
  const steps = read('--lk-rd-spring-soft', '').replace(/^linear\(|\)$/g, '').split(',').map(Number);
  const ease = p => { if (steps.length < 2 || steps.some(isNaN)) return p; const x = p * (steps.length - 1), i = Math.min(Math.floor(x), steps.length - 2); return steps[i] + (steps[i + 1] - steps[i]) * (x - i); };
  function countUp(el) {
    cancelAnimationFrame(el._lkCount); clearTimeout(el._lkCountSafe);
    el.dataset.lkAnimateState = 'done';
    const target = parseFloat(el.dataset.lkCountTo), dec = +(el.dataset.lkCountDecimals || 0);
    const finalText = (el.querySelector(':scope > .visually-hidden')?.textContent ?? el.textContent).trim();
    if (reduced.matches || !isFinite(target) || target <= 0) { el.textContent = finalText; return; }
    const fmt = new Intl.NumberFormat(root.lang || 'de', { minimumFractionDigits: dec, maximumFractionDigits: dec });
    const parts = finalText.split(fmt.format(target));
    const width = el.getBoundingClientRect().width;
    const sr = document.createElement('span'); sr.className = 'visually-hidden'; sr.setAttribute('role', 'status'); sr.textContent = finalText;
    const vis = document.createElement('span'); vis.setAttribute('aria-hidden', 'true');
    vis.style.cssText = `display:inline-block;min-width:${width}px;font-variant-numeric:tabular-nums`;
    el.replaceChildren(sr, vis);
    const show = v => { vis.textContent = (parts.length === 2 ? parts[0] : '') + fmt.format(v) + (parts.length === 2 ? parts[1] : ''); };
    const finish = () => { cancelAnimationFrame(el._lkCount); clearTimeout(el._lkCountSafe); el.textContent = finalText; };
    let t0; show(0);
    const tick = now => {
      t0 ??= now; const p = Math.min(1, (now - t0) / T.count);
      show(dec ? target * ease(p) : Math.floor(target * ease(p)));
      if (p < 1) el._lkCount = requestAnimationFrame(tick); else finish();
    };
    el._lkCount = requestAnimationFrame(tick);
    el._lkCountSafe = setTimeout(finish, T.count + 80); 
  }

  
  const io = 'IntersectionObserver' in window && new IntersectionObserver(entries => {
    const revealNow = [];
    entries.forEach(x => {
      const el = x.target, kind = el.dataset.lkAnimate;
      if (kind === 'entstehen' && x.intersectionRatio >= .08) { io.unobserve(el); revealNow.push(el); }
      if (kind === 'zaehlen' && x.intersectionRatio >= .5) { io.unobserve(el); countUp(el); }
    });
    if (revealNow.length) reveal(revealNow);
  }, { threshold: [.08, .5] });
  function init(scope = document) {
    scope.querySelectorAll('[data-lk-animate]:not([data-lk-animate-state])').forEach(el => {
      if (reduced.matches || !io || !el.animate) { el.dataset.lkAnimateState = 'done'; return; }
      el.dataset.lkAnimateState = 'pending'; io.observe(el);
    });
  }

  
  const OVERLAYS = 'dialog[open], [aria-modal="true"]:not([hidden]), .site-header__drawer.is-active, .drawer.is-active, .modal.is-active, [data-lk-overlay][open], [data-lk-overlay].is-open';
  const checkOverlay = () => {
    const open = [...document.querySelectorAll(OVERLAYS)].some(el => {
      if (el.closest('[hidden], [inert], [aria-hidden="true"]')) return false;
      if (el.matches('dialog') && !el.open) return false;
      const style = getComputedStyle(el);
      return style.display !== 'none' && style.visibility !== 'hidden' && style.visibility !== 'collapse' && el.getClientRects().length > 0;
    });
    root.classList.toggle('lk-overlay-open', open);
  };

  
  init(); checkOverlay();
  let queued = false;
  new MutationObserver(() => {
    if (queued) return; queued = true;
    setTimeout(() => { queued = false; init(); checkOverlay(); }, 50);
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'class', 'hidden', 'inert', 'aria-hidden', 'aria-modal', 'style'] });
  window.addEventListener('resize', checkOverlay, { passive: true });
  reduced.addEventListener('change', () => { if (reduced.matches) document.querySelectorAll('[data-lk-animate-state="pending"]').forEach(el => { io && io.unobserve(el); el.dataset.lkAnimateState = 'done'; }); });

  /* LK | Trust rotation; one timer per toolbar, managed in the central motion asset. */
  const trustControllers = new Map();
  function initTrust(scope = document) {
    scope.querySelectorAll('[data-lk-trust]').forEach(el => {
      if (trustControllers.has(el)) return;
      const slides = [...el.querySelectorAll('[data-lk-trust-slide]')];
      const button = el.querySelector('[data-lk-trust-pause]');
      if (slides.length < 2 || !button) return;
      let index = 0, timer, fade, paused = false, hovered = false;
      button.hidden = false;
      const stop = () => { clearTimeout(timer); fade?.cancel(); fade = null; };
      const blocked = () => paused || hovered || reduced.matches || document.hidden || el.contains(document.activeElement);
      const schedule = () => {
        clearTimeout(timer);
        if (!el.isConnected || blocked()) return;
        timer = setTimeout(next, Number(slides[index].dataset.duration) || 6000);
      };
      function show(nextIndex) {
        stop(); index = nextIndex;
        slides.forEach((slide, i) => { slide.hidden = i !== index; });
        if (!reduced.matches && slides[index].animate) {
          fade = slides[index].animate([{opacity:0},{opacity:1}], {duration:T.soft,easing:curve.soft});
          fade.onfinish = () => { fade?.cancel(); fade = null; };
        }
        schedule();
      }
      function next() { if (blocked()) return; show((index + 1) % slides.length); }
      const onEnter = () => { hovered = true; stop(); };
      const onLeave = () => { hovered = false; schedule(); };
      const onFocus = () => stop();
      const onBlur = () => queueMicrotask(schedule);
      const onClick = () => {
        paused = !paused;
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
        stop(); schedule();
      };
      const refresh = () => { stop(); if (reduced.matches) { index = 0; slides.forEach((s,i) => s.hidden = i !== 0); } schedule(); };
      el.addEventListener('pointerenter',onEnter); el.addEventListener('pointerleave',onLeave);
      el.addEventListener('focusin',onFocus); el.addEventListener('focusout',onBlur);
      button.addEventListener('click',onClick);
      trustControllers.set(el,{refresh,destroy() {
        stop(); el.removeEventListener('pointerenter',onEnter);el.removeEventListener('pointerleave',onLeave);
        el.removeEventListener('focusin',onFocus);el.removeEventListener('focusout',onBlur);button.removeEventListener('click',onClick);
      }});
      schedule();
    });
    trustControllers.forEach((controller,el) => {if (!el.isConnected) {controller.destroy();trustControllers.delete(el);}});
  }
  initTrust();
  document.addEventListener('visibilitychange',() => trustControllers.forEach(c => c.refresh()));
  document.addEventListener('shopify:section:load',() => initTrust());
  document.addEventListener('shopify:section:unload',e => trustControllers.forEach((c,el) => {if(e.target.contains(el)){c.destroy();trustControllers.delete(el);}}));
  reduced.addEventListener('change',() => trustControllers.forEach(c => c.refresh()));

  window.LKMotion = { toggle, animateHeight, countUp, init, checkOverlay };
})();


